var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.baseClassName,
        _vm.rangeMarginValue === 0 ? "zero-ranage-margin" : "",
      ],
      on: {
        mousewheel: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onMouseWheel($event)
        },
      },
    },
    [
      _c("div", { staticClass: "bar" }, [
        _c("div", {
          staticClass: "bar-left",
          style: { width: _vm.barMin + "%" },
          on: { click: _vm.onBarLeftClick },
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "input-type-range input-type-range-min",
          attrs: {
            type: "range",
            min: _vm.minimum,
            max: _vm.maximum,
            step: _vm.step,
          },
          domProps: { value: _vm.valueMin },
          on: {
            input: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onInputMinChange($event)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "thumb thumb-left",
            on: {
              mousedown: _vm.onLeftThumbMousedown,
              touchstart: _vm.onLeftThumbMousedown,
            },
          },
          [
            _c("div", { staticClass: "caption" }, [
              _c("span", { staticClass: "min-caption" }, [
                _vm._v(_vm._s(_vm.minCaption || _vm.barMinVal)),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bar-inner" }, [
          _c("div", {
            staticClass: "bar-inner-left",
            on: { click: _vm.onInnerBarLeftClick },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "bar-inner-right",
            on: { click: _vm.onInnerBarRightClick },
          }),
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "input-type-range input-type-range-max",
          attrs: {
            type: "range",
            min: _vm.minimum,
            max: _vm.maximum,
            step: _vm.step,
          },
          domProps: { value: _vm.valueMax },
          on: {
            input: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.onInputMaxChange($event)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "thumb thumb-right",
            on: {
              mousedown: _vm.onRightThumbMousedown,
              touchstart: _vm.onRightThumbMousedown,
            },
          },
          [
            _c("div", { staticClass: "caption" }, [
              _c("span", { staticClass: "max-caption" }, [
                _vm._v(_vm._s(_vm.maxCaption || _vm.barMaxVal)),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "bar-right",
          style: { width: _vm.barMax + "%" },
          on: { click: _vm.onBarRightClick },
        }),
      ]),
      _vm._v(" "),
      _vm.ruler
        ? _c(
            "div",
            { staticClass: "ruler" },
            _vm._l(_vm.stepCount, function (n) {
              return _c("div", { key: n, staticClass: "ruler-rule" })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.subStepCount
        ? _c(
            "div",
            { staticClass: "sub-ruler" },
            _vm._l(_vm.subStepCount, function (n) {
              return _c("div", { key: n, staticClass: "ruler-sub-rule" })
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c(
            "div",
            { staticClass: "labels" },
            _vm._l(_vm.scaleLabels, function (label) {
              return _c("div", { key: label, staticClass: "label" }, [
                _vm._v("\n      " + _vm._s(label) + "\n    "),
              ])
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }